import angular from 'angular';
import {
    normalizeMovimentacaoValor,
    parseMovimentacaoHorasToMinutes,
    resolveMovimentacaoEntityIdentifier
} from '../../../../Movimentacoes/helpers/movimentacoes-value.helpers';
import {
    createEmptyMovimentacaoAdmissaoForm,
    IMovimentacaoAdmissaoFormModel,
    IMovimentacaoAdmissaoFormState
} from '../../components/form/movimentacoes-admissoes-form.model';
import {
    IMovimentacaoAdmissao,
    IMovimentacaoAdmissaoCreatePayload,
    IMovimentacaoAdmissaoFormModalParams,
    IMovimentacaoAdmissaoFormModalResult,
    IMovimentacaoAdmissaoUpdatePayload
} from '../../models/movimentacoes-admissoes.model';

export class MovimentacoesAdmissoesFormModalController implements angular.IController {
    static $inject = [
        'params',
        '$uibModalInstance',
        'NewToaster'
    ];

    public model: IMovimentacaoAdmissaoFormModel = createEmptyMovimentacaoAdmissaoForm();
    public form: angular.IFormController;
    public formState: IMovimentacaoAdmissaoFormState = {
        valid: false,
        vigenciaFinalInvalida: false
    };

    constructor(
        public params: IMovimentacaoAdmissaoFormModalParams,
        private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
        private NewToaster: { pop: (opts: { type: string; title: string; body?: string }) => void },
    ) { }

    public $onInit(): void {
        this.model = this.buildModel(this.params.movimentacao || null);
    }

    public isEditMode(): boolean {
        return !!this.params.movimentacao;
    }

    public getTitle(): string {
        return this.isEditMode() ? 'Editar movimentação' : 'Adicionar movimentação';
    }

    public onValidityChange(args: { state: IMovimentacaoAdmissaoFormState }): void {
        this.formState = args.state;
    }

    public submit(): void {
        if (this.form) {
            this.form.$setSubmitted();
        }

        if (!this.formState.valid) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Movimentação inválida',
                body: 'Preencha os campos obrigatórios e tente novamente.'
            });
            return;
        }

        const payload = this.buildPayload();
        if (!payload) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Movimentação inválida',
                body: 'Revise o valor informado para a rubrica.'
            });
            return;
        }

        const result: IMovimentacaoAdmissaoFormModalResult = {
            payload,
            model: angular.copy(this.model)
        };

        this.$uibModalInstance.close(result);
    }

    public close(): void {
        this.$uibModalInstance.dismiss('cancelar');
    }

    private buildModel(movimentacao: IMovimentacaoAdmissao | null): IMovimentacaoAdmissaoFormModel {
        const model = createEmptyMovimentacaoAdmissaoForm();

        if (!movimentacao) {
            model.lotacao = this.params.lotacao ? angular.copy(this.params.lotacao) : null;
            return model;
        }

        model.evento = this.buildEventoModel(movimentacao.evento);
        model.lotacao = movimentacao.lotacao || null;
        model.valor = parseMovimentacaoHorasToMinutes(movimentacao.valor) || movimentacao.valor;
        model.referencia = movimentacao.referencia || '';
        model.vigencia = movimentacao.vigencia || 1;
        model.vigenciamesfinal = movimentacao.vigenciamesfinal || null;
        model.vigenciaanofinal = movimentacao.vigenciaanofinal || null;

        return model;
    }

    private buildEventoModel(evento: any): any {
        if (!evento) {
            return null;
        }

        const eventoModel = angular.copy(evento);
        if (eventoModel.codigo && eventoModel.nome) {
            eventoModel.codigo_nome = `${eventoModel.codigo} - ${eventoModel.nome}`;
        }

        return eventoModel;
    }

    private buildPayload(): IMovimentacaoAdmissaoCreatePayload | IMovimentacaoAdmissaoUpdatePayload | null {
        const evento = resolveMovimentacaoEntityIdentifier(this.model.evento, 'evento', 'codigo');
        const lotacao = resolveMovimentacaoEntityIdentifier(this.model.lotacao, 'lotacao', 'codigo');
        const valor = normalizeMovimentacaoValor(this.model.valor, this.model.evento);

        if (!evento || !lotacao || valor === null) {
            return null;
        }

        const basePayload = {
            evento,
            lotacao,
            valor,
            referencia: this.normalizeReferencia(),
            vigencia: this.model.vigencia,
            vigenciamesfinal: this.model.vigencia === 3 ? this.model.vigenciamesfinal : null,
            vigenciaanofinal: this.model.vigencia === 3 ? this.model.vigenciaanofinal : null
        };

        if (this.isEditMode()) {
            return {
                ...basePayload,
                versao: Number(this.params.movimentacao!.versao)
            };
        }

        return {
            ...basePayload,
            solicitacao: this.params.solicitacao
        };
    }

    private normalizeReferencia(): string | null {
        const referencia = `${this.model.referencia || ''}`.trim();
        return referencia ? referencia : null;
    }
}
